import { useAuthContext } from 'contexts/AuthContext';
import { decimalToPercent } from 'ns_libs/formatter';
import useGetProFormaRoom from 'queries/ProForma/useGetProFormaRoom';
import { KeyStatsValues } from '../DealReturns/DealReturns';

interface UseGetProFormaStatsParams {
    dealId: number;
    proFormaId: number | undefined;
}

export const useGetProFormaStats = ({ dealId, proFormaId }: UseGetProFormaStatsParams) => {
    const { selectedOrganizationId } = useAuthContext();

    const { data: proFormaRoomData, isLoading } = useGetProFormaRoom(
        dealId,
        proFormaId!,
        selectedOrganizationId!,
        false,
        '',
        null,
        { enabled: !!proFormaId && !!selectedOrganizationId, staleTime: Infinity },
    );

    const returns = proFormaRoomData?.returns;

    const keyStats: KeyStatsValues = !returns
        ? {
            leveredIrr: null,
            leveredEmx: null,
            developmentSpread: null,
            returnOnCost: null,
            returnOnEquity: null,
            profitReturn: null,
        }
        : {
            leveredIrr: decimalToPercent(returns.netLeveredIrr),
            leveredEmx: returns.netLeveredEquityMultiple ?? null,
            developmentSpread: returns.developmentSpread?.trended ?? null,
            returnOnCost: decimalToPercent(returns.yieldOnCost?.trended),
            returnOnEquity: decimalToPercent(returns.leveredRoi),
            profitReturn: proFormaRoomData.disposition?.netSaleProceeds?.amount ?? null,
        };

    return {
        keyStats,
        isLoading,
        activeProFormaName: proFormaRoomData?.generalInfo?.name || 'Pro Forma',
    };
};
